import type { Environment } from 'src/app/config/environments';
import type {
  CatalogueProductFeature,
  HirerAccount,
} from 'src/graphql/generated';
import type { EmployerSiteName } from 'src/types/app';

export enum PageId {
  CREATE = 'create',
  CLASSIFY = 'classify',
  SELECT_AD_TYPE = 'selectAdType',
  WRITE = 'write',
  MANAGE = 'manage',
  PAY_AND_POST = 'payAndPost',
  SUCCESS = 'success',
  CONCIERGE = 'concierge',
  GUARANTEED_HIRE = 'guaranteed-hire',
  PREMIUM_PLUS = 'premium-plus',
  MULTI_LOCATION = 'multiLocation',
  EDIT = 'edit',
  EDIT_PAY_AND_POST = 'editPayAndPost',
  EDIT_SUCCESS = 'editSuccess',
  REFRESH = 'refresh',
  REFRESH_ERROR = 'refreshError',
  REFRESH_SUCCESS = 'refreshSuccess',
  TEST_PAGE = 'testPage',
}
export interface Feature {
  name: string;
  enabled?: boolean;
}

export interface FeatureConfigInput {
  advertiserId: string;
  env: Environment;
  currentPage?: string;
  hirerAccount: Partial<HirerAccount>;
  productFeatures?: CatalogueProductFeature[];
}

export interface FeatureConfigValue {
  enabled?: boolean;
  percent?: number;
  advertisers?: string[];
  pages?: {
    [key in PageId]?: boolean;
  };
}

export type SiteSpecificFeatureConfigValue = {
  [site in EmployerSiteName]: FeatureConfigValue;
};

export interface FeatureConfig<
  T extends
    | FeatureConfigValue
    | SiteSpecificFeatureConfigValue = FeatureConfigValue,
> {
  name: string;
  value?: {
    [key in Environment]: T;
  };
  toFeature: (input: FeatureConfigInput) => Feature;
}
